<div class="modal-container">
  <div class="modal-header">
    <h2 class="modal-title">Adicionar dataset à conexão</h2>
    <button mat-icon-button class="close-button" (click)="onCancel()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="modal-content">
    @if(step === 1){
    @if(startView === 'choose'){
    <div class="step-content">
      <p class="modal-description">Como deseja cadastrar o dataset?</p>
      <div class="start-options">
        <button type="button" class="start-option" (click)="chooseCsvRegistration()">
          <span class="start-option-title">Enviar arquivo CSV</span>
          <span class="start-option-subtitle">As colunas vêm do arquivo</span>
        </button>
        <button type="button" class="start-option" (click)="startManualRegistration()">
          <span class="start-option-title">Cadastrar sem arquivo</span>
          <span class="start-option-subtitle">Informe nome, coluna temporal e séries</span>
        </button>
        <button type="button" class="start-option" (click)="startDuplicateRegistration()">
          <span class="start-option-title">Duplicar dataset</span>
          <span class="start-option-subtitle">Parte de um dataset já cadastrado nesta conexão</span>
        </button>
      </div>
    </div>
    } @else if(startView === 'csv'){
    <div class="step-content" [formGroup]="form">
      <div class="form-group">
        <label class="form-label">Arquivo CSV</label>
        <app-upload-card
          [subtitle]="'Ainda não há arquivo'"
          [buttonText]="'ENVIAR ARQUIVO'"
          [acceptedFileTypes]="'.csv'"
          [isFileNameEditable]="false"
          [secondType]="true"
          [existingFile]="existingFile"
          (fileUpload)="onFilesSelected($event)"
          (fileDelete)="onFileDelete()">
        </app-upload-card>
        @if(isUploading) {
        <div class="upload-loading">
          <span>Processando arquivo...</span>
        </div>
        }
      </div>
    </div>
    } @else {
    <div class="step-content">
      <p class="modal-description">Escolha o dataset de origem. Nome, descrição, contrato, coluna temporal e séries continuam editáveis.</p>
      @if(loadingDatasets) {
      <span class="modal-description">Carregando datasets...</span>
      } @else if(sourceDatasets.length === 0) {
      <span class="modal-description">Nenhum dataset nesta conexão.</span>
      } @else if(sourceDatasetSelect) {
      <select-input [selectInput]="sourceDatasetSelect" (valueEmitter)="onSourceDatasetChange($event)">
      </select-input>
      }
    </div>
    }
    }
    @else if(step === 2){
    <!-- Etapa 2: Nome e Descrição -->
    <div class="step-content" [formGroup]="form">
      <div class="form-group">
        <text-input [textInput]="seriesNameInput" formControlName="seriesName">
        </text-input>
      </div>

      <div class="form-group">
        <text-input [textInput]="descriptionInput" formControlName="description">
        </text-input>
      </div>

      <div class="form-group">
        <text-input [textInput]="contractIdInput" formControlName="contractId">
        </text-input>
      </div>
    </div>
    }
    @else if(step === 3){
    <!-- Etapa 3: Seleção da Variável Temporal -->
    <div class="step-content" [formGroup]="form">
      @if(registrationMode === 'manual') {
      <p class="modal-description">Informe o nome da coluna temporal.</p>
      <div class="form-group">
        <text-input [textInput]="temporalColumnInput" formControlName="temporalColumn"
          (valueEmitter)="onManualTemporalColumnChange($event)">
        </text-input>
      </div>
      } @else {
      <p class="modal-description">Selecione qual variável representa a coluna temporal da série.</p>
      <div class="form-group">
        @if(temporalColumnSelect) {
        <select-input [selectInput]="temporalColumnSelect" formControlName="temporalColumn"
          (valueEmitter)="onTemporalColumnChange($event)">
        </select-input>
        }
      </div>
      }
    </div>
    }
    @else if(step === 4){
    <!-- Etapa 4: Seleção de Variáveis para Unidade de Medida -->
    <div class="step-content" [formGroup]="form">
      @if(registrationMode === 'manual') {
      <p class="modal-description">Informe o nome e a unidade de cada série.</p>
      <div class="manual-series-list">
        @for (serie of manualSeries; track serie.id; let i = $index) {
        <div class="manual-series-row">
          <text-input [textInput]="{
              value: serie.name,
              label: 'Nome da série',
              placeholder: 'Ex.: carga_mw',
              maxLength: '120',
              disabled: false,
              readonly: false,
              required: { active: true }
            }" (valueEmitter)="updateManualSeriesName(i, $event)">
          </text-input>
          <text-input [textInput]="{
              value: serie.unit,
              label: 'Unidade de medida',
              placeholder: 'Ex.: MW',
              maxLength: '30',
              disabled: false,
              readonly: false,
              required: { active: true }
            }" (valueEmitter)="updateManualSeriesUnit(i, $event)">
          </text-input>
          @if(manualSeries.length > 1) {
          <button type="button" class="remove-series-button" (click)="removeManualSeries(i)">
            <mat-icon>close</mat-icon>
          </button>
          }
        </div>
        }
      </div>
      <button-induxtry [buttonProperties]="{
          label: 'Adicionar série',
          customStyle: 'secondary',
          showLabel: true
        }" (action)="addManualSeries()">
      </button-induxtry>
      } @else {
      <p class="modal-description">Selecione as variáveis que terão unidade de medida e defina a unidade para cada uma.
      </p>

      @if(columns.length > 0) {
      <div class="form-group">
        @if(hasMultipleVariablesForUnits) {
        <label class="checkbox-label select-all-label">
          <input type="checkbox" [checked]="allVariablesSelected"
            (change)="onSelectAllVariablesChange($event.target.checked)">
          <span class="variable-name">Selecionar todas</span>
        </label>
        }
        <div class="variables-selection-list">
          @for (variable of getAvailableVariablesForUnits(); track variable; let i = $index) {
          <div class="variable-selection-item">
            <label class="checkbox-label">
              <input type="checkbox" [checked]="isVariableSelected(variable)"
                (change)="toggleVariableSelection(variable, $event)">
              <span class="variable-name">{{ variable }}</span>
            </label>

            @if(isVariableSelected(variable)) {
            <div class="unit-input-wrapper">
              <text-input [textInput]="{
                value: variablesWithUnits[variable] || '',
                label: 'Unidade de medida',
                placeholder: 'Digite a unidade (ex: kWh, MW, MWh)',
                maxLength: '30',
                required: { active: true }
              }" (valueEmitter)="updateVariableUnit(variable, $event)">
              </text-input>
              @if(i === 0 && hasMultipleVariablesWithUnitOption) {
              <div class="apply-same-unit-toggle">
                <mat-slide-toggle color="primary" [checked]="applySameUnitToAll" (change)="onApplySameUnitToAllChange($event.checked)">
                  Aplicar a mesma unidade de medida a todas as variáveis
                </mat-slide-toggle>
              </div>
              }
            </div>
            }
          </div>
          }
        </div>
      </div>
      }
      }
    </div>
    }
    @else if(step === 5){
    <!-- Etapa 5: Resumo -->
    <div class="step-content summary-step">
      <div class="summary-header">
        <h3 class="summary-title">Resumo da dataset</h3>
        <p class="summary-subtitle">Revise as informações antes de finalizar</p>
      </div>

      <div class="summary-section">
        <!-- Nome da dataset -->
        <div class="summary-card">
          <div class="summary-card-header">
            <h4 class="summary-card-title">Nome da dataset:</h4>
            <span class="summary-value highlight-value">{{ getSeriesName() }}</span>
          </div>
        </div>

        <!-- Descrição -->
        @if(getDescription()) {
        <div class="summary-card">
          <div class="summary-card-header">
            <h4 class="summary-card-title">Descrição:</h4>
            <span class="summary-value highlight-value">{{ getDescription() }}</span>
          </div>
        </div>
        }

        @if(getContractId()) {
        <div class="summary-card">
          <div class="summary-card-header">
            <h4 class="summary-card-title">ID do contrato:</h4>
            <span class="summary-value highlight-value">{{ getContractId() }}</span>
          </div>
        </div>
        }

        <!-- Configuração Temporal -->
        <div class="summary-card">
          <div class="summary-card-header">
            <h4 class="summary-card-title">Variável temporal:</h4>
            <span class="summary-value highlight-value">{{ temporalColumn }}</span>
          </div>
        </div>

        <!-- Unidades de Medida -->
        @if(selectedVariablesForUnits.length > 0) {
        <div class="summary-card">
          <div class="summary-card-header">
            <h4 class="summary-card-title">Séries/Unidades de medida</h4>
            <span class="summary-badge">{{ selectedVariablesForUnits.length }} variável(is)</span>
          </div>
          <div class="summary-card-content">
            <div class="units-grid">
              @for (variable of selectedVariablesForUnits; track variable) {
              <div class="unit-card">
                <span class="unit-variable">{{ variable }}:
                </span>
                <span class="unit-value">{{ variablesWithUnits[variable] }}</span>
              </div>
              }
            </div>
          </div>
        </div>
        } @else {
        <div class="summary-card">
          <div class="summary-card-header">
            <mat-icon class="summary-icon">straighten</mat-icon>
            <h4 class="summary-card-title">Séries/Unidades de medida</h4>
          </div>
          <div class="summary-card-content">
            <p class="empty-message">Nenhuma série/unidade de medida configurada</p>
          </div>
        </div>
        }
      </div>

      @if(registrationMode === 'manual') {
      <div class="form-group processing-file">
        <label class="form-label">Arquivo para processamento (opcional)</label>
        <app-upload-card
          [subtitle]="'Nenhum arquivo será processado'"
          [buttonText]="'ANEXAR ARQUIVO'"
          [isFileNameEditable]="false"
          [secondType]="true"
          [existingFile]="processingExistingFile"
          (fileUpload)="onProcessingFileSelected($event)"
          (fileDelete)="onProcessingFileDelete()">
        </app-upload-card>
      </div>
      }
    </div>
    }
  </div>

  <div class="modal-footer">
    <button-induxtry [buttonProperties]="{
        label: step === 1 && startView === 'choose' ? 'Cancelar' : 'Voltar',
        customStyle: 'secondary',
        showLabel: true
      }" (action)="step === 1 && startView === 'choose' ? onCancel() : onBack()">
    </button-induxtry>

    @if(showNextButton) {
    <button-induxtry [buttonProperties]="{
        label: getButtonLabel(),
        customStyle: 'primary',
        showLabel: true,
        loading: getButtonLoading(),
        disabled: isNextButtonDisabled()
      }" (action)="step === 5 ? onFinish() : onNext()">
    </button-induxtry>
    }
  </div>
</div>